module.exports = __webpack_public_path__ + "static/media/img120.f787c24f.jpg";